import type { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, UserSelect } from '@/components_deprecated'
import { DetectBlur } from '@/containers/util-containers'
import type { ShallowUserNode } from '@/modules/users'
import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import type { DropdownFilter } from '@/types/graphql/enums'

interface SelectUserPromptProps {
  user: ShallowUserNode | null
  dropdownPageName?: DropdownFilter

  onResolve: PromptResolve<ShallowUserNode | null>
}

export const SelectUserPrompt: React.FC<SelectUserPromptProps> = ({
  user,
  dropdownPageName,

  onResolve,
}) => {
  const translations = useTranslate({
    selectResponsibleUser: 'settings.responsible-user',
  })

  const [selectedUser, setSelectedUser] = useState<typeof user>(user)

  return (
    <DetectBlur active onClickOutside={() => onResolve(null)}>
      <RegularModal
        title={translations.selectResponsibleUser}
        onCancel={() => onResolve(null)}
        onSubmit={() => onResolve(selectedUser)}
      >
        <UserSelect
          value={selectedUser?.id ?? null}
          dropdownPageName={dropdownPageName}
          alwaysInclude={user ?? undefined}
          fullWidth={isMobile}
          onChange={(_, node) =>
            !node?.extra ? void 0 : setSelectedUser(node.extra)
          }
        />
      </RegularModal>
    </DetectBlur>
  )
}
